export function About() {
    return (<div>
        <h1>About Me</h1>
        <p>Check out my github <a href={'http://github.com/ethanyu27'}>here</a></p>
    </div>);
}

export default About;